<template>
  <button
    type="button"
    class="ui-theme-toggle"
    :aria-label="theme === 'dark' ? 'Ativar tema claro' : 'Ativar tema escuro'"
    @click="toggleTheme"
  >
    <svg
      class="ui-theme-toggle__icon"
      :class="{ 'ui-theme-toggle__icon--active': theme === 'dark' }"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    >
      <circle cx="12" cy="12" r="4" />
      <path d="M12 2v2M12 20v2M4.93 4.93l1.41 1.41M17.66 17.66l1.41 1.41M2 12h2M20 12h2M6.34 17.66l-1.41 1.41M19.07 4.93l-1.41 1.41" />
    </svg>
    <svg
      class="ui-theme-toggle__icon"
      :class="{ 'ui-theme-toggle__icon--active': theme === 'light' }"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    >
      <path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79Z" />
    </svg>
  </button>
</template>

<script setup>
import useTheme from '../../composables/useTheme';

const { theme, toggleTheme } = useTheme();
</script>

<style scoped>
.ui-theme-toggle {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 6px 10px;
  background: var(--navy-border);
  border: none;
  border-radius: var(--r-pill);
  cursor: pointer;
}

.ui-theme-toggle__icon {
  width: 16px;
  height: 16px;
  color: var(--faint);
  transition: color 0.2s var(--ease);
}

.ui-theme-toggle__icon--active {
  color: var(--cyan);
}
</style>
